// extracted by mini-css-extract-plugin
export default {"videoTitle":"VideoPage_videoTitle__dt1Pc"};